<template>
  <div class="br-pagebody pd-x-20 pd-sm-x-30 distributor-page">
  	<div class="d-flex">
  		<div class="card bd-gray-400 wd-100p" style="padding-right: 20px;">
	    	<div class="pd-b-15 mg-b-15" style="border-bottom: 1px solid #ddd;">
	    		{{$t('product.当前位置：')}}
	    		<router-link class="tx-info" :to="{path:'/product-img'}">{{$t('product.商品相册')}}</router-link>
	    		<span class="mg-x-10">>></span>{{albumItem.name}}
	    	</div>
	    	<div class="d-flex align-items-center">
	    		<label class="ckbox mg-b-1">
					  <input type="checkbox" :checked="isAll" @change="changeAllCheck($event)">
					  <span>{{$t('product.当页全选')}}</span>
					</label>
					<span class="mg-l-15">
						{{$t('product.已选')}}<span class="mg-l-2 mg-r-2">{{checkArr.length}}</span>{{$t('product.张')}}
					</span>
					<a href="javascript:;" class="mg-l-15 tx-info" @click="moveLot()">{{$t('product.移动到')}}</a>
					<a href="javascript:;" class="mg-l-15 tx-info" @click="copyLot">{{$t('product.批量复制')}}</a>
					<a href="javascript:;" class="mg-l-15 tx-info" @click="removeLot()">{{$t('product.批量删除')}}</a>
	    	</div>
	    	<div v-if="itemsDrag.length>0">
		    	<draggable @update="datadragEnd" v-model="itemsDrag" :options="{animation: 300,handle:'.dargDiv'}"  class="ul">
		    		<div class="li dargDiv" v-for="(item, index) in itemsDrag" :key="item.id+index">
							<div class="m_fav_album">
		    				<div class="m_cover m_cover_c pos-relative">
		    					<div class="img_wrap" style="background-size: cover;">
		    						<!--<a
			                href="javascript:;" 
			                v-lazy:background-image="item.majorImageUrl" 
			                >
		                </a>-->
		                <a href="javascript:;" @click="preview(index)">
			                <img v-lazy="item.imgUrl"/>
											<div v-if="item.illegal == 1" class="img-illegal"
												data-toggle="tooltip"
          							data-placement="top"
          							:data-original-title="$t('product.原因：') + item.illReason"
											>
												<div>
													<p class=" tx-bold tx-danger">
														{{item.auditStatus == '3' ? $t('product.图片违规') : $t('product.可能违规')}}
													</p>
													<button v-if="item.auditStatus == '0'" type="button" class=" btn btn-primary btn-sm"
														@click.stop="submitAudit(item)"
													>{{$t('product.申诉')}}</button>
													<span v-if="item.auditStatus == '1'" class=" tx-bold tx-warning">{{$t('product.待审核')}}</span>
													<span v-if="item.auditStatus == '3'" class=" tx-bold tx-gray-700">{{$t('product.审核不通过')}}</span>
												</div>
											</div>	
		                </a>
		    					</div>
		    				</div>
		    				<div class="detail tx-left mg-t-5 tx-12">
		    					<p class="title mg-b-0">
		    						<label class="ckbox mg-b-1">
										  <input type="checkbox" :value="item.id" v-model="checkArr">
										  <span class="d-inline-block tx-ellipsis1" style="max-width: 104px;">{{item.name}}</span>
										</label>
		    					</p>
		    					<p class="mg-b-0">{{item.timeCreated}}</p>
		    				</div>
		    			</div>
	    			</div>
		     	</draggable>
	    	</div>
	    	<div v-else>
	    		<div class="col-12 none-product">
						<i class="fa fa-ban"></i>{{$t('product.没有符合条件的数据')}}
					</div>
	    	</div>
	    </div>
	    <div class="card bd-gray-400 mg-l-10 tx-gray-900" style="width: 220px;min-width: 220px;">
	    	<p class="tx-ellipsis2">{{albumItem.name}}</p>
	    	<a href="javascript:;" class="imgs-wrap" style="background-image: none;">
		        <img v-if="albumItem.imgUrls && albumItem.imgUrls.length" v-lazy="albumItem.imgUrls[0].imgUrl"/>
		        <img v-else v-lazy=""/>
		    </a>
		    <p class="mg-t-15 mg-b-5">{{$t('product.共')}}<span class="tx-black mg-l-2 mg-r-2">{{albumItem.imgCnt}}</span>{{$t('product.张图片')}}</p>
		    <p class="">{{$t('product.还可上传')}}<span class="tx-black mg-l-2 mg-r-2">{{100-albumItem.imgCnt}}</span> {{$t('product.张')}}</p>
		    <p class="mg-b-5">
		    	<span class="tx-gray-600">{{$t('product.访问权限：')}}</span>
		    	<span class="">{{$t($dict.imgsStatus[albumItem.status])}}</span>
		    </p>
		    <p>
		    	<span class="tx-gray-600">{{$t('product.相册类型：')}}</span>
		    	<span class="">{{$t($dict.imgsType[albumItem.type])}}</span>
		    </p>
		    <div class="d-flex justify-content-between">
		    	<button class="btn btn-sm btn-info" @click="editProImg">{{$t('product.编辑相册')}}</button>
		    	<button class="btn btn-sm btn-success" @click="openUpload()">{{$t('product.上传图片')}}</button>
		    </div>
		    
	    </div>
  	</div>
    
  </div>
</template>

<script>
import draggable from 'vuedraggable';
export default {
  props: ["first_loading", "items","albumItem"],
  data() {
    return {
    	scale: [],
    	itemsDrag: [],
    	checkArr: [],
    };
  },
  filters: {
    dateFormat(date) {
      return moment(date, "YYYYMMDD").format("YYYY-MM-DD");
    },
  },
  components: {
  	'draggable': draggable,
  },
  computed: {
  	isAll() {
      return this.items && this.items.length > 0 && this.checkArr.length == this.items.length
        ? true
        : false;
   },
  },
  watch: {
  	items: {
      handler: function() {
      	this.itemsDrag = this.items;
      	this.checkArr = [];
      },
      deep: true
    },
  },
  created() {
    document.body.ondrop = function (event) {
        event.preventDefault();
        event.stopPropagation();
    }
  },
	updated(){
  	$('[data-toggle="tooltip"]').tooltip();
	},
  methods: {
		submitAudit(item){ //违规$t('product.申诉')
			this.$emit('submitAudit', item);
		},
		openUpload(){
			this.$emit('openUpload');
		},
  	preview(index) {
  		this.$parent.loading = true;
  		let imgArr = [];
			this.items.forEach((item) => {
				imgArr.push({
          img: item.imgUrl,
          text: item.name
      	})
			})
			this.$store.commit("setImgItem", imgArr.slice(index).concat(imgArr.slice(0,index)));
	    setTimeout(() => {
	      const viewer = document.querySelector(".app-images-arr").$viewer;
        viewer.show();
        this.$parent.loading = false;
	    }, 500);
    	
    },
  	datadragEnd (evt) {
      console.log(evt)
      this.$parent.loading = true;
  		let newIndex = evt.newIndex;
  		let params = {
  			albumId: this.$parent.id,
  			id: this.itemsDrag[newIndex].id,
  			toId: ""
  		}
  		if(this.itemsDrag[newIndex+1]){
  			params.toId = this.itemsDrag[newIndex+1].id;
  		}
			$.api_call('api.SupplierAlbum.moveImgBySupplier', params, (r) => {
				this.$parent.loading = false;
				if (r.ErrorCode == '9999') {
					this.$parent.getItems();
					ShowTip(this.$t('product.移动成功'), 'success');
				} else {
					if (r.ErrorCode == '1002') {
						userFailure(this);
					} else {
						ShowTip(r.Message, 'danger');
					}
				}
			});
    },
  	timeFormat_1(val) {
      return moment(val, "YYYY-MM-DD H:mm:ss").format("YYYY-MM-DD");
    },
  	changeAllCheck(e) {
      this.checkArr = [];
      if (e.target.checked) {
        this.items.forEach(e => {
          this.checkArr.push(e.id);
        });
      }
    },
    editProImg(){
  		this.$emit("editProImg")
  	},
  	removeLot(){
  		if(this.checkArr.length == 0){
  			ShowTip(this.$t('product.请先选择一张照片'),"danger");
  			return;
  		}
  		this.$emit("removeLot",this.checkArr)
  	},
  	copyLot(){
  		if(this.checkArr.length == 0){
  			ShowTip(this.$t('product.请先选择一张照片'),"danger");
  			return;
  		}
  		this.$emit("copyLot",this.checkArr)
  	},
  	moveLot(){
  		if(this.checkArr.length == 0){
  			ShowTip(this.$t('product.请先选择一张照片'),"danger");
  			return;
  		}
  		this.$emit("moveLot",this.checkArr)
  	},
  }
};
</script>
<style scoped="scoped">
.ul,.li{
	margin: 0px;
  padding: 0px;
	list-style: none;
}
.ul{
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
		justify-content: flex-start;
}
.ul:after{
  content: '';
  flex-grow: 99999;
}
.li{
		max-width: 130px;
    flex: 1;
    text-align: center;
    margin-top: 10px;
    margin-bottom: 10px;
    /*flex:auto;*/      
    padding: 0 0;   
    margin-right: 15px; 
}
.m_fav_album {
    
}
.m_cover .img_wrap {
    position: relative;
}
.m_cover_c .img_wrap {
  position: relative;
}
.m_cover_c .img_wrap img{
	width: 124px;
	height: 124px;
	background-size:cover;
	min-width: 124px;
}
.m_cover_c .img_wrap a {
	position: relative;
  background-size:cover;
  width: 124px;
  height: 124px;
  display: block;
}
.img-illegal{
	position: absolute;		
	top: 0;
	right: 0;
	bottom: 0;
	left: 0;
	background-color: rgba(255, 255, 255, .7);
}
.img-illegal > div{
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
}
.m_fav_pic img, .m_fav_album img {
    vertical-align: bottom;
}
.m_cover_c{
	overflow: hidden;
	border: 1px solid #ddd;
}
.imgs-wrap{
	position: relative;
  background: url(/img/cover_bg.png) no-repeat 0 0;
  background-position: -21px -206px;
  padding: 1px 0 0 1px;
  width: 160px;
  height: 160px;
}
.imgs-wrap img{
	width: 154px;
	height: 154px;
	margin-right: 6px;
}
</style>